import {Injectable} from "@angular/core";
import {TrackableEntityActionService} from "./trackable-entity-action.service";
import {TemplateDTO} from "../common/model/template-dto.model";
import {HttpClient} from "@angular/common/http";
import {NavigationService} from "./navigation.service";
import {Router} from "@angular/router";
import {UserService} from "./user.service";
import {environment} from "../../../environments/environment";
import {CommonService} from "./common.service";
import {FirebaseEventEnum} from "../enum/firebase-event.enum";
import {FirebaseService} from "./firebase.service";
import {Translation} from "../model/translation.model";
import {LanguageService} from "./language.service";

@Injectable(
  {providedIn: 'root'}
)
export class TemplateActionService extends TrackableEntityActionService<TemplateDTO> {

  constructor(private firebaseService: FirebaseService,
              http: HttpClient,
              navigationService: NavigationService,
              router: Router,
              commonService: CommonService,
              userService: UserService) {

    super(http, navigationService, router, userService, commonService, environment.host + "/users/actions/templates");
  }

  public override countCalendarFB(entity: TemplateDTO) {
    console.error("Method not implemented. - EventActionService.countCalendarFB");
  }

  public override countOpenFB(entity: TemplateDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.TEMPLATE_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'opened'
    });

  }

  public override countCallFB() {
    console.error("Method not implemented. - TemplateActionService.countCallFB");
  }

  public override countWhatsappFB(entity: TemplateDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'open-facebook'
    });

  }

  public override countNavigateFB() {
    console.error("Method not implemented. - TemplateActionService.countNavigateFB");
  }

  public override countInstagramFB(entity: TemplateDTO) {
    this.firebaseService.logEvent(FirebaseEventEnum.TEMPLATE_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'open-external-link'
    });

    console.error("Method not implemented. - TemplateActionService.countInstagramFB");
  }

  public override countFacebookFB(entity: TemplateDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'open-facebook'
    });

  }

  public override countExternalLinkFB(entity: TemplateDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.TEMPLATE_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'open-external-link'
    });

  }

  public override countShareFB(entity: TemplateDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'share'
    });

  }

  public override toggleFavoriteFB(entity: TemplateDTO) {

    this.firebaseService.logEvent(FirebaseEventEnum.EVENT_ACTION, {
      template_name: this._getTemplateName(entity.body),
      template_id: entity?.id,
      template_action: 'favorite'
    });

  }

  private _getTemplateName(translations: Translation[]) {
    return LanguageService.getTranslation(translations, 'title');
  }

}
